import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    IndexAssetClassesGetViewResponse,
    IndicesPageGainersLosersGetViewResponse,
    IndicesPagePerformanceGetViewResponse,
} from '../../interfaces/indices-view-responses.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class IndicesService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getMainAssetClassIndices(): Observable<IndexAssetClassesGetViewResponse> {
        return this.getAllAssetClassIndices('root');
    }

    getAllAssetClassIndices(parentAssetClass: string): Observable<IndexAssetClassesGetViewResponse> {
        const urlParams = { asset_class: parentAssetClass };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.ASSET_CLASS_DATA, urlParams);
        return this.ajaxService.getDataObserveBody<IndexAssetClassesGetViewResponse>(url);
    }

    getIndicesPageGainersLosers(
        indexFamily: string,
        periodicity: string
    ): Observable<IndicesPageGainersLosersGetViewResponse> {
        const queryParams = {
            indexFamily,
            periodicity,
        };
        const url = this.urlsService.getUrl(
            this.urlsService.INDICES.INDICES_FAMILY_PAGE_GAINERS_LOSERS,
            {},
            queryParams
        );
        return this.ajaxService.getDataObserveBody<IndicesPageGainersLosersGetViewResponse>(url);
    }

    getIndicesData(indexFamily: string, columns: string[]): Observable<IndicesPagePerformanceGetViewResponse> {
        const queryParams = {
            indexFamily,
            columns,
        };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.INDICES_FAMILY_DATA, {}, queryParams);
        return this.ajaxService.getDataObserveBody<IndicesPagePerformanceGetViewResponse>(url);
    }

    getMajorIndicesData(indices: string[], columns: string[]): Observable<IndicesPagePerformanceGetViewResponse> {
        const queryParams = {
            indices,
            columns,
        };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.INDICES_FAMILY_DATA, {}, queryParams);
        return this.ajaxService.getDataObserveBody<IndicesPagePerformanceGetViewResponse>(url);
    }
}
